import { CountMetric } from '@amzn/ihm-associate-tools-js-lib'
import { setIsAnnouncementsFinished } from '@src/redux/slices/announcementsSlice'
import { store } from '@atredux/store'
import React from 'react'

class AnnouncementsErrorBoundary extends React.Component<any, any> {
    public state: any

    public static getDerivedStateFromError (error) {
        return { hasError: true, error }
    }

    constructor (props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    public componentDidCatch (error, errorInfo) {
        const announcementsErrorCount = new CountMetric(undefined, 'error', 'IhmFlyingDutchman', 'AnnouncementsModal')
        announcementsErrorCount.count(1)
        console.error(`AnnouncementsErrorBoundary: error: ${JSON.stringify(error)}, errorInfo: ${JSON.stringify(errorInfo)}`)
        store.dispatch(setIsAnnouncementsFinished({ isAnnouncementsFinished: true }))
    }

    public render () {
        if (this.state.hasError) {
            return <></>
        }

        return this.props.children
    }
}

export default AnnouncementsErrorBoundary
